import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("mask", {
  id: "a",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: "12",
  y: "9",
  width: "12",
  height: "13"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M23.275 9.77c.142.785.218 1.601.218 2.453 0 3.499-1.2 6.47-3.292 8.549l-.278.266h-3.869v-3.01a5.516 5.516 0 0 0 2.321-3.302l.069-.318H12V9.77h11.275z",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("g", { mask: "url(#a)" }, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.973 21.171h11.653V9.658H11.973V21.17z",
    fill: "#318AF5"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("mask", {
  id: "b",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: "1",
  y: "14",
  width: "19",
  height: "10"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M5.248 14.302c.94 2.83 3.57 4.935 6.68 4.935 1.472 0 2.744-.356 3.769-.97l.273-.172 3.857 3.005c-1.975 1.828-4.676 2.9-7.9 2.9C7.4 24 3.463 21.472 1.44 17.746l-.179-.342v-3.102h3.988z",
    fill: "#fff"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("g", { mask: "url(#b)" }, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.238 24.106h18.621v-9.898H1.238v9.898z",
    fill: "#3DA751"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("mask", {
  id: "c",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "6",
  width: "6",
  height: "12"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M5.232 6.743v3.073a7.116 7.116 0 0 0-.372 2.253c0 .65.094 1.287.262 1.893l.11.36-3.969 3.072A11.845 11.845 0 0 1 1.07 7.148l.193-.405h3.97z",
    fill: "#fff"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("g", { mask: "url(#c)" }, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M-.026 17.55h5.385V6.64H-.026v10.91z",
    fill: "#FDB900"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("mask", {
  id: "d",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: "1",
  y: "0",
  width: "19",
  height: "10"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M11.988 0c3.061 0 5.655 1.076 7.68 2.848l.3.27-3.422 3.434c-1.235-1.185-2.808-1.79-4.558-1.79-3.003 0-5.56 1.969-6.574 4.656l-.1.28L1.33 6.596C3.293 2.683 7.326 0 11.988 0z",
    fill: "#fff"
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("g", { mask: "url(#d)" }, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.308 9.845H20.07V-.053H1.308v9.898z",
    fill: "#EA3E36"
  })
], -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
  ]))
}
export default render